// @flow
// Types
import type { Product } from '../types';

export const isRunningOut = (product: Product) => {
  const LOW_QUANTITY_G_THRESHOLD = 7000;
  const LOW_QUANTITY_UN_THRESHOLD = 5;

  const isProductOutOfStock =
    product.discontinued ||
    !product.inStock ||
    product.totalOnHand < product.defaultQuantity ||
    product.totalOnHand <= 0;

  if (isProductOutOfStock) return false;

  if (product.unitForQuantity === 'g') {
    return product.totalOnHand < LOW_QUANTITY_G_THRESHOLD;
  }

  return product.totalOnHand < LOW_QUANTITY_UN_THRESHOLD;
};
